import React from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { AuthWrapper, AuthContainer, LangDropdown } from 'components/ui/index';
import classNames from 'classnames/bind';
import ForgotPasswordForm from '../components/ForgotPasswordForm';
import styles from '../index.less';

const cx = classNames.bind(styles);

const ForgotPassword = ({ location : { search } }) => {
    const params = new URLSearchParams(search);
    const passwordExpired = params.get('resetRequired') === 'true'
    const messageId = passwordExpired ? 'page.Auth.resetPassword' : 'page.Auth.forgotPassword'
    
    const actions = (
      <div className={cx('forgotPassword-actions-container')}>
        <div>
          <FormattedMessage id="page.Auth.backToLogin" />
          <Link to="/auth/login">
            <FormattedMessage id="page.Auth.login">
              {text => <span style={{ color: '#677dbd' }}>{text}</span>}
            </FormattedMessage>
          </Link>
        </div>
        <LangDropdown />
      </div>
  );

  return (
    <AuthWrapper>
      <AuthContainer
        containerClass={cx('forgotPassword-container')}
        title={<FormattedMessage id={messageId} />}
        actions={actions}
      >
        <ForgotPasswordForm passwordExpired={passwordExpired}/>
      </AuthContainer>
    </AuthWrapper>
)};

export default ForgotPassword;



// WEBPACK FOOTER //
// ./src/views/Auth/ForgotPassword/container/index.jsx